module.exports = __webpack_public_path__ + "img/hieda no akyuu_sc2.afef2856.png";